import React from "react";
import "./radioLiker.scss";

interface RadioLikerProps {
   id: string;
   value: { id: number; name: string };
   name: string;
   isChecked: boolean;
   label: string;
   radioRef?: any;
   onChange: any;
   pos: number;
}

const RadioLiker = (props: RadioLikerProps) => {
   const { id, value, name, isChecked, label, radioRef = null, pos } = props;
   return (
         <label className="radioLikerContainer">
            <div id={`child_${pos}`}></div>
            <input
               type="radio"
               id={id}
               value={JSON.stringify(value)}
               name={name}
               checked={isChecked}
               onChange={props.onChange}
               title={label}
            />
            <span className="radioLikerContainer__checkmark">{pos}</span>
            <span className="radioLikerContainer__tooltip">{value.name}</span>
         </label>
   );
};

export default RadioLiker;
